<template>
    <div class="our-services-section">
        <div class="section-header">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 text-center">
                        <h2>عن بيترونكس</h2>
                    </div>     
                </div>
                
            </div>
        </div>
        <div class="container">
            <div class="row service-desc">
                    <div class="col-xs-12 text-center">
                        <p>
                            ولدت شركة بيترونكس في مطلع عام 2014 بأيدي مهندسين سوريين من مدينة حلب.
نفذت أكثر من  70 مشروعًا مع مختلف الجهات الحكومية والخاصة، ساهمت الشركة بتقديم حلولاً عديدة في مختلف مجالات المجتمع، وساعدت العديد من العملاء على تطوير أسلوب عملهم وجعله أكثر تنظيماً وفعالية.
                        </p>
                    </div>
                </div>
                <div class="row services">
                    <service-box :title="'التصميم الغرافيكي'"
                                 :image="'/static/sections/graphic.png'"
                                 :content="'يختص بتصميم الهويات البصرية والمطبوعات والفيديوهات الإعلانية.'"></service-box>
                    <service-box :title="'هندسة الالكترونيات'"
                                 :image="'/static/sections/electronics.png'"
                                 :content="'يقدم مختلف حلول الطاقة، وتصميم الأنظمة المدمجة، وكذلك أنظمة الحماية المنزلية والصناعية بمختلف أنواعها.'"></service-box>
                    <service-box :title="'تطبيقات الجوال'"
                                 :image="'/static/sections/mobile.png'"
                                 :content="'يختص بتصميم تطبيقات الهاتف المحمول بنوعيها  Android و iOS.'"></service-box>
                    <service-box :title="'تطبيقات الويب'"
                                 :image="'/static/sections/web.png'"
                                 :content="'يختص بتصميم المواقع الالكترونية ونظم الأتمتة وبرمجيات الويب، كما يركز على تطوير برمجيات طرف المخدم.'"></service-box>
                    <service-box :title="'تطبيقات الديسكتوب'"
                                 :image="'/static/sections/software.png'"
                                 :content="'تصميم التطبيقات التي تعمل على نظام ويندوز، كالتطبيقات الخدمية وأنظمة الأتمتة.'"></service-box>
                </div>
        </div>
    </div>
</template>
<script>
import ServiceBox from '@/components/home/service-box'
export default {
  name:'OurServices',
  components:{
      ServiceBox
  }
}
</script>
<style lang="scss" scroped>
    @import "src/assets/sass/shared.scss";

    .section-header{
        h2{
            color:$secondary-color;
            width:35%;
            margin:10px auto;
            @media(max-width:767px){
                width:55%;
            }
            @media(max-width:480px){
                width:80%;
            }
            &::after{
                content: '';
                display: block;
                position: relative;
                background-image: url("/src/assets/img/separator.png");
                background-repeat: no-repeat;
                background-size: cover;
                margin-top: 30px;
                width: 100%;
                padding-bottom:8%;
            }
        }
    }
.our-services-section{
    .container{
        @media(max-width:1200px){
            width:98%;
        }
    }
    .service-desc{
        margin-bottom:30px;
        p{
            font-size:18px;
            direction: rtl;
        }
    }
    .services{
        margin-top:30px;
        margin-bottom:30px;
        display:flex;
        justify-content: space-between;
        @media(max-width:990px){
            flex-wrap:wrap;
        }
        & > div{
            width:25%;
            margin-left:3px;
            margin-right:3px;
            flex-grow:1;
            @media(max-width:767px){
                width:45%;
            }
            @media(max-width:480px){
                width:80%;
                justify-self: center;
            }
        }

        
    }
}
</style>



// WEBPACK FOOTER //
// src/components/home/our-services.vue